import { useContext } from 'react'
import routeSettings from './routes'
import { CoreContext } from '../../../core/context/CoreContext'

const GetNavItems = () => {
  const core = useContext(CoreContext)
  const { showDashboard } = core.user.userSetting
  const { showCampaign } = core.user.selectedCustomer
  const userTypeId = core.user.userSetting.userTypeId
  const showInternalProduct =
    userTypeId === 1 || // Admin
    userTypeId === 5 || // sales person
    userTypeId === 7    // Merchandiser

  const navItem = (id, index, labelKey) => {
    return {
      id: id,
      route: routeSettings.getRoute(id),
      index: index,
      labelKey: labelKey,
    }
  }

  const upperNavigation = [
    navItem('HomePage', 1, 'homePage'),
    navItem('Products', 3, 'productsPage'),
    navItem('Search', 5, 'searchPage'),
    navItem('QuickEntry', 6, 'quickEntryPage'),
    navItem('ReturnService', 8, 'returnServicePage'),
    navItem('Invoices', 9, 'invoicesPage'),
    navItem('Orders', 10, 'ordersPage'),
    navItem('RestOrders', 11, 'restOrders'),
    navItem('Statistics', 12, 'statisticsPage'),
    navItem('Help', 13, 'helpPage'),
  ]

  if (showDashboard) {
    upperNavigation.splice(1, 0, navItem('DashboardPage', 2, 'dashboard'))
  }

  if (showCampaign) {
    upperNavigation.splice(3, 0, navItem("CampaignPageOverView", 4, "campaign"))
  }

  if (showInternalProduct) {
    upperNavigation.splice(5, 0, navItem('InternalProductsPage', 7, 'internalProducts'))
  }


  return {
    upperNavigation,
  }
}

export default GetNavItems
